<template>
  <header id="header" class="container-fluid header">
    <div class="container">
      <div class="row">
        <div class="header-logo-wrapper col-3">
          <router-link to="/" class="header-logo-link">
            <span class="icon-hexagon"></span>
          </router-link>
        </div>
        <div class="header-navigation-wrapper col-9 pl-5">
          <MobileMenu></MobileMenu>
          <ul class="header-navigation-items">
            <li>
              <router-link
                class="header-navigation-items-link home"
                to="/"
              >
                Home
              </router-link>
            </li>
            <li>
              <router-link class="header-navigation-items-link" to="/about-us/">
                About Us
              </router-link>
            </li>
            <li>
              <router-link
                class="header-navigation-items-link"
                to="/voices-of-the-bereaved/"
              >
                Voices of the Bereaved
              </router-link>
            </li>
            <li>
              <router-link
                class="header-navigation-items-link"
                to="/lending-library/"
              >
                Lending Library
              </router-link>
            </li>
            <li>
              <router-link
                class="header-navigation-items-link"
                to="/contact-us/"
              >
                Contact Us
              </router-link>
            </li>
            <li>
              <a href="tel:07759208525" class="navigation-items-tel btn">
                07759 208525
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import MobileMenu from '@/components/partials/MobileMenu'

export default {
  name: 'main-header',
  components: {
    MobileMenu
  }
}
</script>

<style lang="scss">
@import "../../assets/styles/variables/colors";
@import "../../assets/styles/variables/breakpoints";

.header {

  .header-logo-link {
    font-size: 33px;
    text-decoration: none !important;
    color: $black !important;
  }
  .router-link-active {
    text-decoration: underline;
    color: $primary-dark;
  }

  .home.router-link-active {
    text-decoration: none;
    color: $body-text;
  }

  padding: 6px 0;
  &-logo {
    &-link {
      &-img {
        max-width: 250px;
        max-height: 100px;
        @media screen and (max-width: $md-breakpoint) {
          max-width: 180px;
        }
      }
    }
  }
  &-navigation {
    &-wrapper {
      margin: auto 0;
      @media screen and (max-width: $lg-breakpoint) {
        margin: 0;
      }
    }
    &-items {
      margin: 0;
      padding: 0;
      font-size: 18px;

      list-style-type: none;
      display: flex;
      justify-content: space-between;
      align-items: center;
      @media screen and (max-width: $lg-breakpoint) {
        display: none;
      }
      &-link {
        font-weight: 600;
        color: $body-text;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/MainHeader.vue